import {
    FETCH_DATA_FOR_RECOMMENDATION,
    FETCH_DATA_SAVE_FOR_LATER,
    RESET_PRODUCT_CARTRIDGE_REDUCER,
    CERTONA_OPTIONS,
    REMOVE_PRODUCT_CARTRIDGE_SLOT,
    ENSIGHTEN_ERROR_EVENT,
    ADD_PRODUCT_CARTRIDGE_SLOT,
} from '../actionTypes/ProductCartridgeActionTypes';
import {
    RECOMMENDATION_SOURCE_TYPE_ADOBE,
    RECOMMENDATION_SOURCE_TYPE_CERTONA,
    RECOMMENDATION_SOURCE_TYPE_GET_ALL_SAVE_FOR_LATER,
} from '../common/Constants';

export const getProductListForCartridgeSlot = (props) => {
    const {
        pageType,
        deviceType,
        slotId,
        loader,
        attributes,
        host,
        regionZone,
        certonaUrl,
        forceRefresh,
        itemId,
        limit,
        refreshCertona,
        style,
        adobeScheme,
        isLoggedIn,
        isAdobe,
    } = props;
    const payload = {
        pageType,
        deviceType,
        slotId,
        loader,
        attributes,
        host,
        regionZone,
        certonaUrl,
        forceRefresh,
        itemId,
        limit,
        refreshCertona,
        style,
        adobeScheme,
        isLoggedIn,
        isAdobe,
    };

    let invokeLoader = loader;

    // Each loader should have unique constant name to trigger respective watcher saga
    switch (loader) {
        case RECOMMENDATION_SOURCE_TYPE_ADOBE:
        case RECOMMENDATION_SOURCE_TYPE_CERTONA:
            invokeLoader = FETCH_DATA_FOR_RECOMMENDATION;
            break;
        case RECOMMENDATION_SOURCE_TYPE_GET_ALL_SAVE_FOR_LATER:
            invokeLoader = FETCH_DATA_SAVE_FOR_LATER;
            break;
        default:
            break;
    }

    return {
        type: invokeLoader,
        payload,
    };
};

/* istanbul ignore next */
export const resetProductCartridgeStore = () => ({
    type: RESET_PRODUCT_CARTRIDGE_REDUCER,
});

/* istanbul ignore next */
export const addCertonaOptions = (payload) => ({
    type: CERTONA_OPTIONS,
    payload,
});

/* istanbul ignore next */
export const removeProductCartridgeSlot = (schemaName) => ({
    type: REMOVE_PRODUCT_CARTRIDGE_SLOT,
    schemaName,
});

export const addProductCartridgeSlot = (slotData) => ({
    type: ADD_PRODUCT_CARTRIDGE_SLOT,
    slotData,
});

/* istanbul ignore next */
export const triggerEnsightenEvent = (payload) => ({
    type: ENSIGHTEN_ERROR_EVENT,
    payload,
});

export default {
    getProductListForCartridgeSlot,
    removeProductCartridgeSlot,
    resetProductCartridgeStore,
    addCertonaOptions,
    triggerEnsightenEvent,
    addProductCartridgeSlot,
};
